import { CostLineItem } from 'types/Load';
import { MaybeUndef } from 'types/UtilityTypes';
import { normalizeToArray } from 'utils/loadInfoAndBuilding';

import { PlsFormAccessorialItem } from '../types';
import { plsAccessorialCodeFromValue } from '../utils';

// The PLS accessorial code a rate card charge stands for, as create reads it: its
// accessorialCode, else its label. Empty for a charge with neither.
export function plsChargeAccessorialCode(
  charge: MaybeUndef<Pick<CostLineItem, 'label' | 'accessorialCode'>>
): string {
  return (charge?.accessorialCode?.trim() || charge?.label?.trim() || '')
    .toUpperCase()
    .trim();
}

// The accessorials picked in Specs, by code, with the rate create sends for each when the rate
// card doesn't price it (PLS's default rate, or 0).
export function plsSpecsAccessorialRates(
  accessorials: MaybeUndef<PlsFormAccessorialItem[]>
): Map<string, number> {
  const rates = new Map<string, number>();
  (normalizeToArray(accessorials ?? undefined) ?? []).forEach((item) => {
    const code = (
      item?.code?.trim() ||
      plsAccessorialCodeFromValue(item?.value) ||
      ''
    ).toUpperCase();
    if (!code || rates.has(code)) {
      return;
    }
    const rate = Number(item?.value);
    rates.set(code, Number.isFinite(rate) && rate > 0 ? rate : 0);
  });
  return rates;
}

// A rate card charge for an accessorial picked in Specs, at the rate create would send for it.
export function plsSpecsAccessorialCharge(
  code: string,
  rate: number
): CostLineItem {
  return {
    label: code,
    accessorialCode: code,
    unitBasis: '',
    quantity: 1,
    ratePerUnitUSD: rate,
    totalChargeUSD: rate,
    note: '',
  };
}
